import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/general-website/v3/'

// 菜单模板列表
export const getMenuTplList = params => axios({
  url: `${commonPath}menu_template/query`,
  method: 'post',
  data: params
})

// 菜单模板激活/归档
export const activeMenuTpl = params => axios({
  url: `${commonPath}menu_template/active`,
  method: 'post',
  data: params
})

// 菜单显示
export const displayMenu = params => axios({
  url: `${commonPath}menu/exchange_show`,
  method: 'post',
  data: params
})

// 菜单排序
export const sortMenu = params => axios({
  url: `${commonPath}menu/exchange_sort`,
  method: 'post',
  data: params
})

// 菜单模板排序
export const sortMenuTpl = params => axios({
  url: `${commonPath}websiteTemplate/menuTemplate_exchange_sort`,
  method: 'post',
  data: params
})

// 菜单模板创建/更新
export const saveMenuTpl = params => axios({
  url: `${commonPath}menu_template/save`,
  method: 'post',
  data: params
})

// 菜单模板详情
export const getMenuTplDetail = id => axios({
  url: `${commonPath}menu_template/detail/${id}`,
  method: 'get'
})
